import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const products = async (data: ProductsReqT) => {
  const { pageParam, title, categoryId } = data;

  const qs = `?page=${pageParam ?? 1}&title=${title ?? ""}&category_id=${
    categoryId ?? ""
  }`;
  return axios.get(Routes.PRODUCTS + qs);
};

export const useProducts = (params: ProductsReqT) => {
  const { title, categoryId } = params;

  return useInfiniteQuery({
    queryKey: [Keys.NOTES_QRY, title, categoryId],
    queryFn: ({ pageParam = 1 }) => products({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
